"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowDown = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ArrowDown = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M13.44 18.555a1.493 1.493 0 01-1.06.445h-.76a1.533 1.533 0 01-1.06-.445L.296 8.168a1.016 1.016 0 010-1.434l1.42-1.435a.976.976 0 011.4 0L12 14.29 20.883 5.3a.995.995 0 011.42 0l1.401 1.435a1.015 1.015 0 010 1.434L13.44 18.555z" })); };
exports.ArrowDown = ArrowDown;
//# sourceMappingURL=arrow-down.js.map